import {
  words,
} from './globalState';
import { syncHttpRequest2 } from './utils';

// GET ACTIVATION LIST
// eslint-disable-next-line no-unused-vars
async function getActivationList() {
  return;
}

// ACTIVATE MONATOKA POINT
async function handleClickActivateMonatokaPoint(state, dispatch) {
  // let signature;
  let request = {};
  let messages = {};
  // let result;

  // state固定
  const stateFixed = {
    addressMainEncrypted: state.activation.addressMainEncrypted,
    // addressActivator: Object.keys(state.session)[0],
    addressActivator: state.active.addressMain,
    // sessionId: Object.values(state.session)[0].sessionId,
    sessionId: state.session[state.active.addressMain]?.sessionId,
    // signatureVersion: state.config.clientParameters.signatureVersion.applyForCardRegistration,
    // addressCheck: state.addressCheck,
  };

  // 必須項目チェック
  if (stateFixed.addressMainEncrypted === undefined || stateFixed.addressMainEncrypted === null || stateFixed.addressMainEncrypted === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.activationCode[state.language] });
    return;
  }

  request.body = JSON.stringify({
    body: {
      addressMainEncrypted: stateFixed.addressMainEncrypted,
      addressActivator: stateFixed.addressActivator,
      sessionId: stateFixed.sessionId,
    }
  });

  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/activate_monatoka_point';
  request.method = 'POST';

  messages = {
    // "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    // "bad signature": words.badSignature[state.language],
    // "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    // "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    // "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    // "signature by asset owner is required.": words.signatureByAssetOwnerIsRequired[state.language],
    // "asset is required; not asset_longname.": words.assetIsRequiredNotAssetLongname[state.language],
    // "No such token exists.": words.noSuchTokenExists[state.language],
    // "you are not delegated.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    // "addressMainActual must be filled.": words.clearYourBrowserOrAppCache[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'setUp',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: clientTime,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
  }
  else {
  }

  return response;
}

// HANDLE CLICK GET ACTIVATION HISTORY
async function handleClickGetActivationHistory(state, dispatch, pagingIndex) {
  // let addressActual;
  // let start;
  // let end;
  let request = {};
  let messages = {};
  // let certifications = [];
  // const now = Date.now();

  // state固定
  const stateFixed = {
    action: state.activationList.action,
    addressMainEncrypted: state.activation.addressMainEncrypted,
    // addressActivator: Object.keys(state.session)[0],
    addressActivator: state.active.addressMain,
    sessionId: state.session[state.active.addressMain]?.sessionId,
    lastEvaluatedKey: pagingIndex >= 1 ? state.activationList.lastEvaluatedKey[state.activationList.action][pagingIndex - 1] : null,
    // lastEvaluatedSortKey: pagingIndex >= 1 ? state.activationList.lastEvaluatedKey[state.activationList.action][pagingIndex - 1]?.duelNo : null,
    // lastEvaluatedKey2: pagingIndex >= 1 ? state.activationList.lastEvaluatedKey2[state.activationList.action]?.[pagingIndex - 1] : null,
    // lastEvaluatedSortKey2: pagingIndex >= 1 ? state.activationList.lastEvaluatedKey2[state.activationList.action]?.[pagingIndex - 1]?.duelNo : null,
  };


  // -- 検索対象アドレスチェック
  if (stateFixed.action === 'activationHistoryAddressMainEncrypted') {
    if (stateFixed.addressMainEncrypted === undefined || stateFixed.addressMainEncrypted === null || stateFixed.addressMainEncrypted === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.duelistAddressMustBeFilled[state.language] });
      return { status: 'rejected' };
    }
  }


  request.body = JSON.stringify({
    body: {
      action: stateFixed.action,
      authenticationMethod: 'sessionId',
      addressMainEncrypted: stateFixed.addressMainEncrypted,
      // lastEvaluatedSortKey: stateFixed.lastEvaluatedSortKey,
      // lastEvaluatedKey2: stateFixed.lastEvaluatedKey2,
      // lastEvaluatedSortKey2: stateFixed.lastEvaluatedSortKey2,
      certifications: [
        {
          address: stateFixed.addressActivator,
          sessionId: stateFixed.sessionId,
          lastEvaluatedKey: stateFixed.lastEvaluatedKey,
        },
      ],
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);
  dispatch({ type: 'setStateMultiLayers', keys: ['activationList', stateFixed.action], value: response.body[stateFixed.addressActivator] });

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    if (response.body[stateFixed.addressActivator].lastEvaluatedKey !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: response.body[stateFixed.addressActivator].lastEvaluatedKey });
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: null });
    }

    // if (response.body.lastEvaluatedKey2 !== undefined) {
    //   dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey2', stateFixed.action, pagingIndex], value: response.body.lastEvaluatedKey2 });
    // }
    // else {
    //   dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey2', stateFixed.action, pagingIndex], value: null });
    // }

    dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'pagingIndex', stateFixed.action], value: pagingIndex });

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'searchPurchaseHistory',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: now,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

export {
  handleClickActivateMonatokaPoint,
  handleClickGetActivationHistory,
};